import type { RowData } from "../components/details-table/types";
import type { DifficultyRowData } from "../components/difficulty-table/types";
import type { DifficultyModel, GrainInfoModel } from "../services";

export function transformExamDataToTableData(
  apiData?: GrainInfoModel[]
): RowData[] {
  return (
    apiData?.map((item) => {
      return {
        id: item.grainId.toString(),
        topic: item.grainName,
        finalScore: `${item.mark.toFixed(2)}%`,
        answerRate: `${item.answerRate.toFixed(2)}%`,
        accuracy: `${item.accuracyRate.toFixed(2)}%`,
        correct: item.corrects,
        wrong: item.inCorrects,
        skipped: item.noAnswers,
        total: item.corrects + item.inCorrects + item.noAnswers,
        status: item.performanceLabel as RowData["status"]
      };
    }) ?? []
  );
}

export function transformExamDataToDifficultyTableData(
  apiData?: DifficultyModel[]
): DifficultyRowData[] {
  return (
    apiData?.map((item) => {
      return {
        id: item.levelName,
        topic: item.levelName,
        finalScore: `${item.mark.toFixed(2)}%`,
        answerRate: `${item.answerRate.toFixed(2)}%`,
        accuracy: `${item.accuracyRate.toFixed(2)}%`,
        correct: item.corrects,
        wrong: item.inCorrects,
        skipped: item.noAnswers,
        total: item.corrects + item.inCorrects + item.noAnswers
      };
    }) ?? []
  );
}
